import React, { useEffect, useContext } from "react"
import { useNavigate } from "react-router-dom"
import {
  Avatar,
  Box,
  Link,
  Button,
  Card,
  CardContent,
  Grid,
  Modal,
  Typography,
} from "@mui/material"
import i18n from "i18n"
import cardImage1 from "assets/images/freeTrial/image_card1.svg"
import cardImage2 from "assets/images/freeTrial/intercom.png"
import AuthContext from "context/auth/authContext"
import SubscriptionContext from "context/subscription/subscriptionContext"
import { isOnAuthPage } from "utils/functions"

const ModalDebtor = () => {
  const navigate = useNavigate()
  const { user, getUser, logOut } = useContext(AuthContext)
  const { modalDebtor } = useContext(SubscriptionContext)

  useEffect(() => {
    if (!user && !isOnAuthPage()) {
      getUser()
    }
  }, [user])

  const cardsData = [
    {
      id: crypto.randomUUID(),
      image: cardImage1,
      buttonText: i18n.t("modalDebtor.payNow"),
      action: () => {
        navigate("/subscription")
        window.location.reload()
      },
    },
    {
      id: crypto.randomUUID(),
      image: cardImage2,
      buttonText: i18n.t("modalDebtor.contactUs"),
      action: () => {
        try {
          window.Intercom("show")
        } catch (e) {
          console.error("Error opening Intercom", e)
        }
      },
    },
  ]

  const handleLogout = () => {
    logOut()
    setTimeout(() => {
      navigate("/")
      window.location.reload()
    }, 1000)
  }

  return (
    <Modal open={modalDebtor.open} onClose={() => {}} sx={{ zIndex: 1100 }}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          p: 4,
          borderRadius: 2,
          maxHeight: "90vh",
          maxWidth: 600,
          overflowY: "auto",
        }}
      >
        <Typography id="modal-title" variant="h6" sx={{ fontWeight: 600 }}>
          {i18n.t("modalDebtor.title")}
        </Typography>

        <Typography variant="body1" sx={{ mb: 4 }}>
          {i18n.t("modalDebtor.message")}
        </Typography>

        <Grid container spacing={2}>
          {cardsData.map(card => (
            <Grid item xs={12} sm={6} md={6} key={card.id}>
              <Card
                sx={{
                  textAlign: "center",
                  p: 2,
                  boxShadow: "none",
                  border: "none",
                  borderColor: "divider",
                  borderRadius: 2,
                }}
              >
                <CardContent>
                  <Avatar
                    src={card.image}
                    alt={`Opción ${card.id}`}
                    sx={{
                      width: { xs: 100, sm: 120, md: 150 },
                      height: { xs: 100, sm: 120, md: 150 },
                      mx: "auto",
                      mb: 2,
                    }}
                  />
                  <Button
                    variant="contained"
                    color="branded"
                    onClick={card.action}
                    sx={{
                      width: "100%",
                      textTransform: "none",
                    }}
                  >
                    {card.buttonText}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Typography variant="body2" textAlign="center">
          {i18n.t("modalDebtor.contactMessage")}{" "}
          <Link
            href="mailto:soporte@planhopper.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            soporte@planhopper.com
          </Link>
        </Typography>

        <Button
          variant="outlined"
          color="primary"
          onClick={handleLogout}
          sx={{ mt: 4, display: "block", mx: "auto" }}
        >
          {i18n.t("modalDebtor.logout")}
        </Button>
      </Box>
    </Modal>
  )
}

export default ModalDebtor
